module.exports = __webpack_public_path__ + "static/media/foodshot30.47617fb4.JPG";